export const formatDate = (dateString) => {
  if (!dateString) return '-';
  // Adiciona a correção de fuso horário para garantir que a data exibida seja a correta
  const date = new Date(dateString);
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + userTimezoneOffset).toLocaleDateString('pt-BR');
};

export const getFUPStatus = (fupDate) => {
  if (!fupDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const fup = new Date(fupDate);
  // Corrige o fuso horário também na comparação
  const userTimezoneOffset = fup.getTimezoneOffset() * 60000;
  fup.setTime(fup.getTime() + userTimezoneOffset);
  fup.setHours(0, 0, 0, 0);

  const diffDays = Math.floor((fup - today) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return { status: 'overdue', label: 'Atrasado' };
  if (diffDays === 0) return { status: 'today', label: 'Hoje' };
  return { status: 'future', label: `${diffDays} dias` };
};